import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, KeyRound, ArrowLeft, Dices } from "lucide-react";
import { adminLogin, setToken } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "../hooks/use-toast";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const { token } = await adminLogin(password);
      setToken(token);
      toast({ title: "Welcome", description: "Logged in successfully." });
      navigate("/admin");
    } catch (err) {
      toast({
        title: "Login failed",
        description: err?.response?.data?.detail || "Invalid password",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0b0f1a] relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/4 left-1/3 w-[500px] h-[500px] bg-amber-500/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/3 w-[400px] h-[400px] bg-rose-500/10 rounded-full blur-[120px]" />
      </div>

      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-amber-300 mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>

        <div className="rounded-2xl border border-amber-400/15 bg-[#11172a] p-7 shadow-2xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-300 to-amber-500 flex items-center justify-center">
              <Dices className="w-5 h-5 text-[#0b0f1a]" strokeWidth={2.5} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-amber-300 font-semibold">Admin</div>
              <div className="text-xl font-bold text-slate-100">Madhur Lottery</div>
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="text-sm text-slate-300 mb-1.5 flex items-center gap-1.5">
                <Lock className="w-3.5 h-3.5 text-amber-300" /> Admin Password
              </label>
              <Input
                type="password"
                placeholder="Enter admin password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#0e1424] border-white/10 text-slate-100 placeholder:text-slate-500 focus-visible:ring-amber-400/40"
                autoFocus
              />
            </div>
            <Button
              type="submit"
              disabled={loading || !password}
              className="w-full bg-amber-400 hover:bg-amber-300 text-[#0b0f1a] font-semibold"
            >
              <KeyRound className="w-4 h-4 mr-1.5" />
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>

          <p className="mt-5 text-xs text-slate-500 leading-relaxed">
            Single-admin login. Password is managed via server environment.
          </p>
        </div>
      </div>
    </div>
  );
}
